import axios from "./axios";
import { toast } from "react-hot-toast";

export const reverseGeoCode = async (latitude = "", longitude = "") => {
  const reverseGeoCodeBaseURL =
    "https://nominatim.openstreetmap.org/reverse?format=json&";
  try {
    const response = await axios
      .get(reverseGeoCodeBaseURL + "lat=" + latitude + "&lon=" + longitude)
      .catch((err) => {
        toast.error("Reverse Geocode Error");
        console.log(err);
        return { status: 500, message: "Reverse Geocode Error" };
      });
    // console.log(response.status);
    return { status: response.status, data: response.data };
  } catch (err) {
    toast.error("Reverse Geocode Error");
    console.log(err);
    return { status: 500, message: "Reverse Geocode Error" };
  }
};
